import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as analytics from 'shared/lib/analytics';
import compact from 'lodash/compact';
import find from 'lodash/find';
import get from 'lodash/get';
import AddressSection from 'shared/lib/components/AddressSection';
import PaymentLayout from 'shared/lib/components/PaymentLayout';
import LineItemsList from 'shared/lib/components/LineItemsList';
import SectionWrapper from 'shared/lib/components/SectionWrapper';
import './BaggagePaymentView.css';

const propTypes = {
  airlines: PropTypes.array,
  baggageAirline: PropTypes.string,
  baggageCheckout: PropTypes.object,
  baggageConfirmationNumber: PropTypes.string,
  baggageLocation: PropTypes.object,
  baggagePassengerInfo: PropTypes.object,
  baggagePlans: PropTypes.array,
  disclaimer: PropTypes.string,
  isBaggageInProgress: PropTypes.bool,
  purchaseBaggage: PropTypes.func,
  totals: PropTypes.object,
};

const defaultProps = {
  airlines: [],
  baggageAirline: '',
  baggageCheckout: {},
  baggageConfirmationNumber: '',
  baggageLocation: {},
  baggagePassengerInfo: {},
  baggagePlans: [],
  disclaimer: null,
  isBaggageInProgress: false,
  totals: {},
  purchaseBaggage: () => {},
  getAirlines: () => {},
};

class BaggagePaymentView extends PureComponent {
  componentDidMount() {
    analytics.page('BRB - Add Manual Payment Method', { category: 'user' });
    analytics.track('Checkout Step Viewed', {
      category: 'order',
      step: 2,
    });
  }

  handleSubmit = ({ cardElement }) => {
    this.props.purchaseBaggage(cardElement).then(() => {
      this.props.navTo('/baggage-protection/confirmation');
    });
  };

  get plan() {
    return find(this.props.baggagePlans, {
      plan_id: this.props.baggageSelectedPlanId,
    });
  }

  get flightName() {
    const airline = find(this.props.airlines, {
      fs: this.props.baggageAirline,
    });
    return get(airline, 'name');
  }

  render() {
    return (
      <div className="BaggagePaymentView Container Container--small">
        <PaymentLayout
          title={`${get(this.plan, 'information.title')} Baggage Protection`}
          policyDocUrl={get(this.plan, 'policy_doc_url')}
          icon="work"
          isPurchaseInProgress={this.props.isBaggageInProgress}
          totals={this.props.totals}
          acknowledgmentHtml={get(this.plan, 'information.acknowledgment_html')}
          disclaimer={this.props.disclaimer}
          onSubmit={this.handleSubmit}
        >
          <SectionWrapper title="Flight details">
            <p>
              {this.flightName}
              <br />
              Confirmation #{this.props.baggageConfirmationNumber}
            </p>
          </SectionWrapper>

          <SectionWrapper title="Passenger details">
            <p>
              {compact([
                this.props.baggagePassengerInfo.firstName,
                this.props.baggagePassengerInfo.middleName,
                this.props.baggagePassengerInfo.lastName,
              ]).join(' ')}
            </p>
            <AddressSection address={this.props.baggageLocation} />
            <p>
              {this.props.baggagePassengerInfo.email}
              <br />
              {this.props.baggagePassengerInfo.phone}
            </p>
          </SectionWrapper>

          <SectionWrapper>
            <LineItemsList
              rows={[
                ['Underwritten By', 'Blue Ribbon Bags'],
                [
                  'Coverage',
                  get(this.plan, 'information.subtitle').split(' ')[0],
                ],
              ]}
            />
          </SectionWrapper>
        </PaymentLayout>
      </div>
    );
  }
}

BaggagePaymentView.propTypes = propTypes;
BaggagePaymentView.defaultProps = defaultProps;

export default BaggagePaymentView;
